import { template } from 'lodash';
import { queryStringToObject, objectToQueryString } from '../lib/utils';

export const compileInitialState = (pageData, location) => {
  const queryStringParameters = queryStringToObject(location.search);
  const initialState = {
    ...pageData,
    userInput: {},
    queryStringParameters,
    url: location.toString(),
    shareUrl: location.toString().split('?')[0]
  };

  if (
    queryStringParameters.electorate &&
    pageData.electorates.some((e) => e.id === queryStringParameters.electorate)
  ) {
    initialState.userInput.selectedElectorateId =
      queryStringParameters.electorate;
  }
  if (
    queryStringParameters.party &&
    pageData.parties.some((p) => p.id === queryStringParameters.party)
  ) {
    initialState.userInput.selectedPartyId = queryStringParameters.party;
  }
  if (
    queryStringParameters.mp &&
    pageData.mps.some((mp) => mp.id === queryStringParameters.mp)
  ) {
    initialState.userInput.selectedMPId = queryStringParameters.mp;
  }

  return initialState;
};

const buildPath = (basePath, queryStringParameters) => {
  const qs = objectToQueryString(queryStringParameters);
  return qs === '' ? basePath : `${basePath}?${qs}`;
};

export const choosePath = (queryStringParameters) => {
  return buildPath(`/choose`, queryStringParameters);
};

export const lookupPath = (queryStringParameters) => {
  return buildPath(`/`, queryStringParameters);
};

export const createPath = (queryStringParameters) => {
  return buildPath(`/create`, queryStringParameters);
};

export const emailPath = (queryStringParameters) => {
  return buildPath(`/email`, queryStringParameters);
};

export const mpPartyElectorateText = (mp, party, electorate) => {
  if (mp.politicalOffice !== null) {
    return mp.politicalOffice;
  }

  return electorate.id === 'list'
    ? `${party.name} list MP`
    : `${party.name} MP for ${electorate.name}`;
};

// TODO: Find a better place for these
export const generateEmailSubject = (state) => {
  const {
    emailSubject,
    userInput: { firstName, lastName }
  } = state;
  const messageData = {
    senderName: `${firstName} ${lastName}`
  };
  return template(emailSubject)(messageData);
};

export const generateEmailMessage = (state) => {
  const {
    talkingPoints,
    emailTemplate,
    mps,
    parties,
    electorates,
    userInput: {
      selectedElectorateId,
      selectedPartyId,
      selectedMPId,
      firstName,
      lastName,
      email,
      selectedTalkingPointsIds,
      personalMessage
    }
  } = state;
  const selectedMP = mps.find((mp) => mp.id === selectedMPId);
  const selectedMPParty = parties.find((p) => p.id === selectedMP.partyId);
  const selectedMPElectorate = electorates.find(
    (e) => e.id === selectedMP.electorateId
  );

  const messageData = {
    mpName: selectedMP.name,
    talkingPoints: selectedTalkingPointsIds
      .map(
        (stp) =>
          talkingPoints.find((tp) => stp === tp.table.id).table.talking_point
      )
      .join('\n\n'),
    personalMessage,
    senderName: `${firstName} ${lastName}`,
    senderEmail: email,
    party:
      selectedPartyId === selectedMP.partyId ? selectedMPParty.name : false,
    electorate:
      selectedElectorateId === selectedMP.electorateId
        ? selectedMPElectorate.name
        : false
  };

  return template(emailTemplate)(messageData);
};
